import type { MediaMode } from "@echopaste/protocol";

export function shouldUseMediaPipeline(mode: MediaMode, hasFile: boolean): boolean {
  return hasFile || mode === "notebook_delivery";
}

export function classifyMediaKind(mime: string): "image" | "file" {
  return mime.toLowerCase().startsWith("image/") ? "image" : "file";
}
